import { Typography } from '@mui/material';
import { ROLES } from '../../../../utils/constants/roles';
import StyledSwitch from '../../../StyledSwitch/StyledSwitch';
import { TextAndSwitchContainer } from './RoleToggle.styles';

const RoleToggle = ({ userClaims, onRoleToggle }) => {
  return (
    <TextAndSwitchContainer>
      <Typography variant="bodyRegular">Owner</Typography>
      <StyledSwitch
        checked={userClaims.role === ROLES.OWNER}
        onChange={(e) => onRoleToggle(e.target.checked)}
        color="primary"
        ariaLabel="Toggle Owner role"
      />
    </TextAndSwitchContainer>
  );
};

export default RoleToggle;
